<div class="container">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="Ação de Governo"
            page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/preparation.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/acoes-governo']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label style="font-weight: bold; color: #757575">
            {{login.orgao.codigo}} {{login.orgao.nome}}
          </label>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="form-group col-md-12">
              <label for="acao">Ação de governo</label>
              <input value="{{entidadeForm.get('acao.codigo').value}} {{entidadeForm.get('acao.nome').value}}"
                type="text" class="form-control-plaintext font-weight-bold" id="acao">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="executora">Unidade executora</label>
              <input value="{{entidadeForm.get('executora.codigo').value}} {{entidadeForm.get('executora.nome').value}}"
                type="text" class="form-control-plaintext" id="executora">
            </div>
          </div>
          <hr class="mt-3 mb-2" />
          <div class="form-row">
            <div class="form-group col-12">
              <label for="meta">Programa</label>
              <input
                value="{{entidadeForm.get('meta.programa.codigo').value}} {{entidadeForm.get('meta.programa.nome').value}}"
                type="text" class="form-control-plaintext font-weight-bold" style="color: #0277bd" id="meta">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <table class="table table-eddy table-bordered">
                <thead>
                  <tr style="background-color: #eeeeee;">
                    <th scope="col" colspan="4" class="text-center">META FÍSICA</th>
                  </tr>
                  <tr>
                    <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano1}}</th>
                    <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano2}}</th>
                    <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano3}}</th>
                    <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano4}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input unmask="true" [imask]="imaskConfig" formControlName="meta1" type="text"
                        class="form-control-plaintext float-right" id="meta1" readonly
                        style="font-weight: bold; text-align: center">
                    </td>
                    <td>
                      <input unmask="true" [imask]="imaskConfig" formControlName="meta2" type="text"
                        class="form-control-plaintext" id="meta2" readonly
                        style="font-weight: bold; text-align: center">
                    </td>
                    <td class="text-center">
                      <input unmask="true" [imask]="imaskConfig" formControlName="meta3" type="text"
                        class="form-control-plaintext" id="meta3" readonly
                        style="font-weight: bold;  text-align: center">
                    </td>
                    <td class="text-center">
                      <input unmask="true" [imask]="imaskConfig" formControlName="meta4" type="text"
                        class="form-control-plaintext" id="meta4" readonly
                        style="font-weight: bold; text-align: center">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <table class="table table-eddy table-bordered">
                <thead>
                  <tr style="background-color: #eeeeee;">
                    <th scope="col" colspan="4" class="text-center">CUSTO POR EXERCÍCIO</th>
                  </tr>
                  <tr>
                    <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano1}}</th>
                    <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano2}}</th>
                    <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano3}}</th>
                    <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano4}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input unmask="true" [imask]="imaskConfig" formControlName="custo1" type="text"
                        class="form-control-plaintext float-right" id="custo1" readonly
                        style="font-weight: bold; text-align: center">
                    </td>
                    <td>
                      <input unmask="true" [imask]="imaskConfig" formControlName="custo2" type="text"
                        class="form-control-plaintext" id="custo2" readonly
                        style="font-weight: bold; text-align: center">
                    </td>
                    <td class="text-center">
                      <input unmask="true" [imask]="imaskConfig" formControlName="custo3" type="text"
                        class="form-control-plaintext" id="custo3" readonly
                        style="font-weight: bold;  text-align: center">
                    </td>
                    <td class="text-center">
                      <input unmask="true" [imask]="imaskConfig" formControlName="custo4" type="text"
                        class="form-control-plaintext" id="custo4" readonly
                        style="font-weight: bold; text-align: center">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- <pre *ngIf="entidadeForm">{{ entidadeForm | json}}</pre> -->
    </form>
  </div>
</div>